import React, { useState, useRef } from 'react';
import { Turl } from './tUrl.js'
import './css/Deposit.css'; // Создайте этот CSS файл
import { t } from 'ttag';
import { mixpanel } from './mp.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

function Deposit({ wallet, depWallet, isDoDep, setisDoDep, setErrorMessage, handlesetIndex, setIsAuthorized }) {
    const text = wallet
    const [isCopied, setIsCopied] = useState(false);

    const copyToClipboard = async () => {
        mixpanel.track('buyingEquity-copyToClipboard')
        try {
            await navigator.clipboard.writeText(wallet);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000); // Сброс состояния через 2 секунды
        } catch (err) {
            console.error('Failed to copy text: ', err);
            // Можно добавить обработку ошибки (например, показать сообщение пользователю)
        }
    };

    const doDep1 = () => {
        mixpanel.track('buyingEquity-alredyPaid')
        setisDoDep(true);
        doDep();
    }

    const doDep = async () => {
        try {
            const _userData = tg ? tg.initData : null;
            let userData = { initData: _userData }
            if (userData) {
                const response = await fetch(Turl + '/api/doDep', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(userData)
                });


                if (!response.ok) { // Check if the response status indicates an error
                    setisDoDep(false);
                    setErrorMessage(response.message || `HTTP error! Status: ${response.status}`);
                }
                const rData = await response.json(); // Пытаемся разобрать детали ошибки из ответа


                if (rData.status == 9) {
                    setisDoDep(false);
                    setErrorMessage(`Not enough usdt in the account: ${rData.volume}, try leter.`);
                }
                if (rData.status == 1) {
                    setisDoDep(false);
                    setErrorMessage(`${rData.volume} USDT processed successfully`);
                    handlesetIndex(0);
                    setIsAuthorized(false);

                }

                setisDoDep(false);

            } else {
                setisDoDep(false);
                // Handle case where user data is not available (e.g., show error)
                console.warn("Telegram user data not available.");
                // You might want to display an error message to the user here.

            }

        } catch (error) {
            setisDoDep(false);
            console.error('Authentication error:', error);
            setErrorMessage(error.message || 'An unexpected error occurred.');

        }
    };


    return (

        <div style={{ width: "100%" }}>
            <div className="copyable-text-container">
                <div className="text-display">
                    {text}
                </div>
                <button className="copy-button" onClick={copyToClipboard}>
                    {isCopied ? t`Copied!` : t`Copy`}
                </button>
            </div>

            <div className="deposit-blok">
                <div className="deposit-blok-sub">
                    {t`Send the amount of USDT to this BEP-20 address.`}
                </div>
            </div>
        </div >
    );
}

export { Deposit };